import React from 'react';
import { connect } from 'react-redux';
import Past from './Past';
import { PostVisitSummarySagaActions } from '../../../../sagas/postVisitSummary';
import { ADDITIONAL_NOTES_FIELD, PRESCRIPTIONS_FIELD } from './components/VisitNotes';
import { EMPTY_OBJECT } from '../../../../core/util/object';

const mapStateToProps = (state: any, ownProps: any) => ({
  notes: state.bookingNotes[ownProps.booking.id] || EMPTY_OBJECT,
});

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  fetchBookingNotes: () => {
    const { booking } = ownProps;
    dispatch({
      type: PostVisitSummarySagaActions.FETCH_BOOKING_NOTES,
      bookingId: booking.id,
    });
  },

  saveBookingNotes: (form: any, onSuccess: any) => {
    const { booking } = ownProps;
    dispatch({
      type: PostVisitSummarySagaActions.SAVE_BOOKING_NOTES,
      bookingId: booking.id,
      notes: form[ADDITIONAL_NOTES_FIELD],
      prescriptionFilled: Boolean(form[PRESCRIPTIONS_FIELD]),
      prescriptions: form[PRESCRIPTIONS_FIELD],
      onSuccess,
    });
  },

  updateBookingNotes: (form: any, onSuccess: any) => {
    const { booking } = ownProps;
    dispatch({
      type: PostVisitSummarySagaActions.UPDATE_BOOKING_NOTES,
      bookingId: booking.id,
      notes: form[ADDITIONAL_NOTES_FIELD],
      prescriptionFilled: Boolean(form[PRESCRIPTIONS_FIELD]),
      prescriptions: form[PRESCRIPTIONS_FIELD],
      onSuccess,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Past);
